import React from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { GitBranch, GitMerge } from 'lucide-react';

const LogicNode = ({ data, selected }) => {
  const Icon = data.subtype === 'router' ? GitMerge : GitBranch;

  return (
    <div style={{
      padding: '16px',
      borderRadius: '12px',
      border: `2px solid ${selected ? '#0284c7' : '#0ea5e9'}`,
      background: 'rgba(14, 165, 233, 0.1)',
      minWidth: '200px',
      boxShadow: selected ? '0 0 20px rgba(14, 165, 233, 0.4)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.2s'
    }}>
      <Handle type="target" position={Position.Left} style={{ background: '#0ea5e9', width: 12, height: 12, border: '2px solid white' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Icon size={20} color="#0ea5e9" />
        <div>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#1f2937' }}>
            {data.label || 'Logic'}
          </div>
          <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
            {data.subtype || 'condition'}
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} style={{ background: '#0ea5e9', width: 12, height: 12, border: '2px solid white' }} />
    </div>
  );
};

export default LogicNode;
